import DoAPICall from './DoAPICall'

//Create Revenue Point
    export async function createRevenuePoint(userToken, revenuePoint){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'revenuepoints',
            payLoad:{
                description:revenuePoint.description,
                client_id:revenuePoint.client_id,
                name:revenuePoint.name,
                code:revenuePoint.code
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All Revenue Point
    export async function getRevenuePoints(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'revenuepoints',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One Revenue Point
    export async function getRevenuePoint(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'revenuepoints/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get Revenue Points of client
export async function getRevenuePointsOfClient(userToken,client_id){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'revenuepointsofclient/'+client_id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Update Revenue Point
    export async function updateRevenuePoint(userToken, revenuePoint){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'revenuepoints/'+revenuePoint.id,
            payLoad:{
                description:revenuePoint.description,
                client_id:revenuePoint.client_id,
                name:revenuePoint.name,
                code:revenuePoint.code
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete Revenue Point
    export async function deleteRevenuePoint(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'revenuepoints/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }
